import 'bootstrap';
import { initHeroBlocks } from './blocks/hero';
import { initBannerBlocks } from './blocks/banner';
import { initFooterInteractions } from './blocks/footer';
import { initHeaderOverlayMenu } from './blocks/header';
import { initHomepageCitiesCardsBlocks } from './blocks/homepage-cities-cards';
import { initSinglePartnerBlocks } from './blocks/single-partner';
import { initSingleComuniBlocks } from './blocks/single-comuni';
import { initSingleEsperienzaBlocks } from './blocks/single-esperienza';
import { initImageGalleryBlocks } from './blocks/image-gallery';
import { initPartnerLocator } from './blocks/taxonomy-partner-locator';
import { initFilteredGrid } from './blocks/filtered-grid';
import { initHeaderInteractions } from './blocks/header-dropdown';
import { initMapImages } from './blocks/map-image';


/* Bundle js */
document.addEventListener('DOMContentLoaded', () => {
    initHeroBlocks();
    initBannerBlocks();
    initFooterInteractions();
    initHeaderOverlayMenu();
    initHomepageCitiesCardsBlocks();
    initSinglePartnerBlocks();
    initSingleComuniBlocks();
    initSingleEsperienzaBlocks();
    initImageGalleryBlocks();
    initPartnerLocator();
    initFilteredGrid();
    initHeaderInteractions();
    initMapImages();
    /**
     Swiper object becomes available after mapo blocks plugin (> 1.3.1) is enabled
     */
    /*
    if (typeof window.Swiper === 'undefined') {
        const swiper = new Swiper('.swiper', {
            // Optional parameters
            slidesPerView: 3,
            loop: true,
        });
    }
    */
})